import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore';

export const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, token } = useAuthStore();
  const location = useLocation();

  const hasToken = Boolean(isAuthenticated && token);

  if (!hasToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
